import { Component } from '@theme/component';

class MtTrio extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.selection = [null, null, null];
    this.slots = [...this.querySelectorAll('[data-slot]')];
    this.initial = this.slots.map(slot => slot.innerHTML);
    this.dialog = this.querySelector('dialog');
    this.add = this.querySelector('[data-add-trio]');
    this.label = this.add.textContent;
    this.slots.forEach((slot, i) => {
      slot.disabled = false;
      slot.addEventListener('click', () => {
        this.active = i;
        this.previousFocus = slot;
        this.querySelector('[data-remove-slot]').hidden = !this.selection[i];
        this.dialog.showModal();
      }, { signal });
    });
    this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('close', () => this.previousFocus?.focus(), { signal });
    this.querySelector('[data-remove-slot]').addEventListener('click', () => {
      this.selection[this.active] = null;
      this.updateSelection();
      this.dialog.close();
    }, { signal });
    this.querySelector('[data-trio-search]').addEventListener('input', event => {
      const query = this.normalize(event.target.value);
      let found = 0;
      this.querySelectorAll('[data-trio-product]').forEach(card => {
        card.hidden = !this.normalize(card.dataset.title).includes(query);
        if (!card.hidden) found++;
      });
      this.querySelector('[data-trio-empty]').hidden = found > 0;
    }, { signal });
    this.querySelectorAll('[data-trio-product]').forEach(card => {
      const select = card.querySelector('select');
      select.addEventListener('change', () => { card.querySelector('img').src = select.selectedOptions[0].dataset.image; card.querySelector('img').removeAttribute('srcset'); }, { signal });
      card.querySelector('[data-select-product]').addEventListener('click', () => {
        const option = select.selectedOptions[0];
        this.selection[this.active] = { id: option.value, title: card.dataset.title, variant: option.textContent.trim(), image: option.dataset.image, stock: Number(option.dataset.stock) };
        this.updateSelection();
        this.dialog.close();
      }, { signal });
    });
    this.add.addEventListener('click', () => this.addTrio(), { signal });
    this.updateSelection();
  }
  normalize(value) { return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  updateSelection() {
    this.slots.forEach((slot, i) => {
      const product = this.selection[i];
      slot.innerHTML = this.initial[i];
      slot.toggleAttribute('data-filled', Boolean(product));
      if (!product) return;
      const output = slot.querySelector('[data-selection]');
      output.replaceChildren();
      const img = document.createElement('img');
      img.src = product.image; img.alt = ''; img.width = 110; img.height = 110;
      const title = document.createElement('span'); title.textContent = product.title.replace(/^Montre (Homme|Femme) /, '');
      const variant = document.createElement('small'); variant.textContent = product.variant;
      output.append(img, title, variant);
    });
    const count = this.selection.filter(Boolean).length;
    this.querySelector('[data-count-output]').textContent = this.dataset.count.replace('[count]', String(count));
    this.querySelector('[data-error-output]').textContent = '';
    this.add.disabled = count !== 3;
  }
  async addTrio() {
    if (this.selection.some(item => !item) || this.add.disabled) return;
    const items = [];
    for (const product of this.selection) {
      const item = items.find(item => item.id === product.id);
      if (item) item.quantity++; else items.push({ id: product.id, quantity: 1 });
    }
    if (items.some(item => item.quantity > this.selection.find(p => p.id === item.id).stock)) {
      this.querySelector('[data-error-output]').textContent = this.dataset.error;
      return;
    }
    this.add.disabled = true;
    this.add.textContent = this.dataset.busy;
    try {
      const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }), signal: this.abort.signal });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(this.dataset.error);
      window.location.assign(this.dataset.cartUrl);
    } catch (error) {
      if (error.name === 'AbortError') return;
      this.querySelector('[data-error-output]').textContent = this.dataset.error;
      this.add.disabled = false;
      this.add.textContent = this.label;
    }
  }
  disconnectedCallback() { super.disconnectedCallback(); this.abort?.abort(); }
}
if (!customElements.get('mt-trio')) customElements.define('mt-trio', MtTrio);
